<template>
  <div>
    <div class="row grid-row align-items-center"
      v-for="(header,index) in chargesHeaders"
      :key="index"
      :class="{'bgfield':header.readOnly,'activeblock': (activeColumn === header.column)}" >
        <div class="col-7 grid-title">{{header.label}}</div>
        <div class="col-3 grid-count">
          <PopupDetails
            :smallCell="true"
            :readOnly="header.readOnly"
            :hideSystem="isHideSystemCharge(header.column)"
            :header="header"
            :discrepancy="discrepancy && discrepancy[header.discrepancyColumn]"
            :transporter="transporterCharges && transporterCharges[header.column]"
            :system="systemCharges && systemCharges[header.column]"
            :action="!(isOpenOrder && header.noActionForOpen) && header.action"
            :actualTransporter="actualTransporterCharges && actualTransporterCharges[header.column]"
            :isShipperChargesFeatureEnabled="isShipperChargesFeatureEnabled"
            @updateCharge="updateCharge"
            @currentActiveElement="currentActiveElement"/>
        </div>
    </div>
    <div class="row align-items-center">
      <div class="col-7 grid-title resulttext">Total</div>
      <div class="col-3 resultvalue grid-count">
        {{total}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ChargeMixin from '@common/mixins/ChargeMixin';
import { getTransporterCharges } from '@common/lib/payments';
import PopupDetails from '../actions/PopupDetails';
import { ChargesBy } from 'pando-constants';

export default {
  props: {
    chargesHeaders: {
      type: Array,
      default: () => [],
    },
    charges: {
      type: Array,
      default: () => [],
    },
    tempCharge: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    isOpenOrder: {
      type: Boolean,
      default: false,
    },
    discrepancyCharges: {
      type: Array,
      default: () => [],
    },
    orderType: {
      type: Number,
      default: null,
    },
    isShipperChargesFeatureEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PopupDetails,
  },
  mixins: [ChargeMixin],
  data() {
    return {
      activeColumn: '',
      editableHeader: {},
    };
  },
  mounted() {
    this.editableHeader = this.processEditableHeader;
  },
  computed: {
    ...mapGetters({
      currentClientConfig: 'app/currentClientConfig',
    }),
    transporterCharges() {
      const actualCharges = getTransporterCharges(this.charges);
      return { ...actualCharges, ...this.tempCharge };
    },
    actualTransporterCharges() {
      return this.isShipperChargesFeatureEnabled
        ? (this.charges && this.charges.find(c => c.charges_by === ChargesBy.ACTUAL_TRANSPORTER)) || {}
        : getTransporterCharges(this.charges);
    },
    processEditableHeader() {
      const { payment_settings: paymentSettings } = this.currentClientConfig;
      if (paymentSettings && paymentSettings.transporter_charge_editable) {
        const settings = paymentSettings.transporter_charge_editable[this.orderType];
        // CHECK SETTINGS PRESENT FOR ORDER TYPE(Contract,open,market or use default)
        if (settings) {
          const editableChargeHeaders = [];
          Object.assign(editableChargeHeaders, this.chargesHeaders);
          return editableChargeHeaders.reduce((acc, charge) => {
            acc.push(this.canEditCharge(settings, charge));
            return acc;
          }, []);
        }
      }
      return this.chargesHeaders;
    },
  },
  methods: {
    updateCharge(value) {
      const charges = this.updateChargeObj(value, this.transporterCharges, ChargesBy.TRANSPORTER);
      this.$store.commit('paymentsV2/updateTempCharges', { index: this.index, value: charges });
      this.$emit('updateTempConsignee', 'charges', charges, this.index);
      this.totalCompute();
    },
    isHideSystemCharge(column) {
      const { payment_settings: paymentSettings } = this.currentClientConfig;
      return (paymentSettings && paymentSettings.column_hide_view) &&
        paymentSettings.column_hide_view[column];
    },
    currentActiveElement(activeColumn) {
      this.activeColumn = activeColumn;
    },
  },
};
</script>
